<template>
  <div>
    <div class="inline">
      <el-divider direction="vertical"></el-divider>
      <h3 class="Xjiao">{{$t("menu.CompanyDnamic") }}</h3>
    </div>

    <div class="fff">
      <div v-for="(item,index) in NewList" :key="index">
      <el-row>
        <el-col :span="9">
          <el-image class="SanJiao" :src="item.cover" alt=""></el-image>
        </el-col>
        <el-col :span="15">
          <h3>{{item.title}}</h3>
          <p >
          {{ellipsis(item.details)}}
          </p>
          <el-row style="margin-top: 30px">
            <el-col :span="17">
              <span>{{item.releaseDate}}</span>
            </el-col>
            <el-col :span="7">             
            <router-link  :to="{path:'/CompanyDnamic/Particulars',query: {ti:item.pid,category:'Company'}}">
              <el-button size="mini" round >{{$t("menu.particulars") }}</el-button>
            </router-link>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider class="divider"></el-divider>
</div>

      <!-- 分页 -->
      <el-pagination
        background
        layout="prev, pager, next"
        :total="this.total"
        :current-page="this.page"
        :page-size="this.size"
        @current-change="handleCurrentChange" >
      </el-pagination>
    </div>
  </div>
</template>

<style lang="less" scoped>
    .SanJiao {
      width: 280px;
      height: 158px;
    }
    .divider {
      background-color: #eeeeee;
    }
    .fff {
      background: #ffffff;
      padding: 20px; 
      margin-bottom: 20px;
    }


    h3 {
      font-size: 20px;
    }
    p {
      color: #999999; 
      font-size: 16px;
    }
    span {
      font-size: 12px;
      color: #999999;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background: #1d2088;
    }

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #979df2;
    }  
</style>

  
<script>

export default {
  name: "CompanyDnamicRight",

  data() {
    return {
      title:"",
    
      // queryInfo: {
        //  query:"",
        //当前的页数
        page: 0,
        size: 5, //多少条数据\
        category: "Company",

      // },
      total: 0,
      NewList:[],

    };
    
  },
  created: function () {
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }

    
    this.getSelect();
  },

      computed:{
        ellipsis(){
          return function(value){
           
          if (!value) return '';
          value = value.replace(/<[^>]+>/g, '');
          if (value.length > 90) {
           
             console.log(value.slice(0,90))
            return value.slice(0,90) + '...'
          }
          return value;
          }
          


        }

      },
  methods: {
    // 查询数据
    async getSelect() {
      const { data: resER } = await this.$http.get("/News/GetNewsInfo", {
 params: {page:this.page,size:this.size,category:this.category,languageType:this.title}
      });
           if (resER.code !== 200) return console.log("数据请求失败! ");
   this.NewList=resER.data;
   this.total=resER.total
   console.log(   this.NewList)
    },
// 页码改变事件
    handleCurrentChange(val) {
      this.page = val;
        this.getSelect();
    },
// 点击详情
    // btnSelect(val){
    //   this.$router.push();
    // }

  },
};
</script>   